export enum CopilotUserSessionMessageType {
	USER = 'HumanMessage',
	AI = 'AIMessage'
}